import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
  userStocks: {
    books: 0,
    magazines: 0,
    childrenMagazines: 0,
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = {
        ...action.payload,
        token: undefined
      };
      state.userStocks = action.payload.userStocks || initialState.userStocks;
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo));
    },
    logout: (state) => {
      state.userInfo = null;
      state.userStocks = initialState.userStocks;
      localStorage.removeItem('userInfo');
    },
    clearData: (state) => {
      state.userInfo = null;
      state.userStocks = initialState.userStocks;
    }
  }
});

export default authSlice.reducer;
export const { setCredentials, logout, clearData } = authSlice.actions;
